import React from 'react';
import GrowthAnalysis from './GrowthAnalysis';

const Depletion = () => {
    return (
        <div>
            <GrowthAnalysis from="depletion" />
        </div>
    );
};

export default Depletion;
